const Data = [
    {
        id: 1,
        title: "My CSS Flex-box Profile",
        deployedLink: "https://jenieb3.github.io/spio-garbrah-portfolio/",
        githubLink: "https://github.com/jenieb3/spio-garbrah-portfolio",
        screenshot: "project-one.png"
    },
    {
        id: 2,
        title: "Console Finances",
        deployedLink: "https://jenieb3.github.io/console-finances/",
        githubLink: "https://github.com/jenieb3/console-finances",
        screenshot: "project-two.png"
    },

    {
        id: 3,
        title: "Password-Generator",
        deployedLink: "https://jenieb3.github.io/password-generator/",
        githubLink: "https://github.com/jenieb3/password-generator",
        screenshot: "generate-password.png"
    },
    {
        id: 4,
        title: "Calendar Application",
        deployedLink: "https://jenieb3.github.io/calendar-application/",
        githubLink: "https://github.com/jenieb3/calendar-application",
        screenshot: "workday-schedule.png"
    },
    {
        id: 5,
        title: "Weather Application",
        deployedLink: "https://jenieb3.github.io/weather-forecast/",
        githubLink: "https://github.com/jenieb3/weather-forecast",
        screenshot: "forecast-city.png"
    },
    {
        id: 6,
        title: "Team Generator",
        deployedLink: "https://github.com/jenieb3/team-profile-generator",
        githubLink: "https://github.com/jenieb3/team-profile-generator",
        screenshot: "team-page.png"
    },
];

export default Data;